import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Actions, ofActionCompleted, Store } from '@ngxs/store';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Folders } from '../state/actions';

@Component({
  selector: 'folders-tab-rename-file',
  templateUrl: './rename-file.component.html',
  styleUrls: ['./rename-file.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FoldersTabRenameFileComponent extends OnDestroyMixin implements OnInit {
  public renameFileForm: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<FoldersTabRenameFileComponent>,
    private _formBuilder: UntypedFormBuilder,
    private store: Store,
    private actions: Actions,
  ) {
    super();
  }

  ngOnInit(): void {
    this.renameFileForm = this._formBuilder.group({
      name: [this.data.file.name, [Validators.required, Validators.minLength(3)]],
    });

    this.actions.pipe(untilComponentDestroyed(this), ofActionCompleted(Folders.UpdateFile)).subscribe(() => {
      this.matDialogRef.close();
    });
  }

  discard(): void {
    this.matDialogRef.close();
  }

  save(): void {
    if (this.renameFileForm.invalid) return;

    let file = this.renameFileForm.value;
    file.id = this.data.file.id;

    this.store.dispatch(new Folders.UpdateFile(this.data.file.folder_resource_id, file));
  }
}
